import React, { useEffect, useRef, useState } from "react";
import { Breadcum } from "../../../../components/breadcum";
import { NavLink } from "react-router-dom";
import { ContentParikshaTestDataList } from "./list";
import FormBuilder from "../../../../components/form-builder";
import { GET_ABHYAS_QUESTION_LIST } from "../../../../app/service/abhyas-question.service";
import { toast } from "react-toastify";
import { GET_BOARD_FILTER_LIST, GET_CHAPTER_FILTER_LIST, GET_MEDIUM_FILTER_LIST, GET_STANDARD_FILTER_LIST, GET_SUBJECT_FILTER_LIST } from "../../../../app/service/common-module.service";
import moment from "moment";
import { ContentParikshaAddTestQuestion } from "./add-questions";


export const ContentParikshaTestInfo = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingData, setLoadingData] = useState<boolean>(true);
    const [standardLoading, setStandardLoading] = useState<boolean>(false);
    const [subjectLoading, setSubjectLoading] = useState<boolean>(false);
    const [chapterLoading, setChapterLoading] = useState<boolean>(false);
    const [questionsLoading, setQuestionsLoading] = useState<boolean>(false);
    const [boardsList, setBoardsList] = useState<any>([]);
    const [mediumList, setMediumList] = useState<any>([]);
    const [standardList, setStandardList] = useState<any>([]);
    const [subjectList, setSubjectList] = useState<any>([]);
    const [chapterList, setChapterList] = useState<any>([]);
    const [testList, setTestList] = useState<any>([]);
    const [questionsList, setQuestionsList] = useState<any>([]);
    const [filterData, setFilterData] = useState<any>({
        board_uuid: '',
        medium_uuid: '',
        standard_uuid: '',
        subject_uuid: '',
        chapter_uuid: '',
        exam_type: ''
    });
    const [showComponent, setShowComponent] = useState<string>("");
    const filterForm = useRef<any>({});
    ///  Questions///
    const [testsLoading, setTestsLoading] = useState<boolean>(true);
    const [canShowTestQuestions, setCanShowTestQuestions] = useState<boolean>(false);
    const [testInfo, setTestInfo] = useState<any>({});
    const [canSelectTest, setCanSelectTest] = useState<boolean>(false);
    const [breadcumInfo, setBreadcumInfo] = useState<any>([
        {
            label: 'Content',
            value: 'Content',
            routerLink: '/dashboard/content/view',
            isActive: false
        },
        {
            label: 'Test Creation (Pariksha)',
            value: 'Test Creation (Pariksha)',
            routerLink: '',
            isActive: true
        }
    ]);

    useEffect(() => {
        getBoardData();
    }, [])
    const getBoardData = () => {
        setLoading(true);
        GET_BOARD_FILTER_LIST().then((res: any) => {
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res?.err);
                    setLoading(false);
                } else {
                    const data = res['rows'];
                    setBoardsList(data);
                    setLoading(false);
                }
            }
        });
    }


    const handleInput = (data: any) => {
        let preData = { ...data.value }
        setFilterData(preData);
        setLoadingData(false);
        setTimeout(() => {
            setLoadingData(true);
        }, 100);
    };
    const onChangeBoard = (e: any) => {
        setTestsLoading(false);
        setCanShowTestQuestions(true);
        setMediumList([]);
        setStandardList([]);
        setSubjectList([]);
        setChapterList([]);
        setTestList([]);
        setQuestionsList([]);
        setCanShowTestQuestions(false);
        if (e) {
            getmediumData(e);
        } else {

            setTestsLoading(true);
        }
        const boardName = boardsList?.find((item: any) => item.uuid === e);
        const data = testInfo;
        data.board_name = boardName?.name;
        data.board_uuid = e;
        data.medium_uuid = '';
        data.standard_uuid = '';
        data.subject_uuid = '';
        data.chapter_uuid = '';
        data.exam_type = '';
        setTestInfo({ ...data });

    }

    const getmediumData = (id: any) => {
        GET_MEDIUM_FILTER_LIST(id).then((res: any) => {
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res?.err);
                    setTestsLoading(true);

                } else {
                    const data = res['rows'];
                    setMediumList(data);
                    setTestsLoading(true);

                }
            }
        });

    }

    const onChangeMedium = (e: any) => {
        setStandardList([]);
        setSubjectList([]);
        setChapterList([]);
        setTestList([]);
        setQuestionsList([]);
        setTestsLoading(false);
        if (e) {
            getStandardData(e);
        } else {
            setTestsLoading(true);
        }
        const mediumName = mediumList?.find((item: any) => item.uuid === e);
        const data = testInfo;
        data.medium_uuid = e;
        data.medium_name = mediumName?.name;
        data.standard_uuid = '';
        data.subject_uuid = '';
        data.chapter_uuid = '';
        data.exam_type = '';
        setTestInfo({ ...data });
    }

    const getStandardData = (id: any) => {
        GET_STANDARD_FILTER_LIST(id).then((res: any) => {
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res?.err);
                    setStandardLoading(false);
                    setTestsLoading(true);
                } else {
                    const data = res['rows'];
                    setStandardList(data);
                    setStandardLoading(false);
                    setTestsLoading(true);
                }
            }
        });
    }

    const onChangeStandard = (e: any) => {
        setSubjectList([]);
        setChapterList([]);
        setTestList([]);
        setQuestionsList([]);
        setTestsLoading(false);
        if (e) {
            setShowComponent(e);
            setSubjectLoading(true);
            getSubjectsData(e);
        } else {
            setTestsLoading(true);
        }
        const standardName = standardList?.find((item: any) => item.uuid === e);
        const data = testInfo;
        data.standard_uuid = e;
        data.standard_name = standardName?.standard;
        data.subject_uuid = '';
        data.chapter_uuid = '';
        data.exam_type = '';
        setTestInfo({ ...data });
    }

    const getSubjectsData = (id: any) => {
        GET_SUBJECT_FILTER_LIST(id).then((res: any) => {
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res?.err);
                    setSubjectLoading(false);
                    setTestsLoading(true);
                } else {
                    const data = res['rows'];
                    setSubjectList(data);
                    setSubjectLoading(false);
                    setTestsLoading(true);
                }
            }
        });
    }

    const onChangeSubject = (e: any) => {
        setChapterList([]);
        setQuestionsList([]);
        setTestsLoading(false);
        if (e) {
            getChaptersData(e);
        } else {
            setTestsLoading(true);
        }
        const subjectName = subjectList?.find((item: any) => item.uuid === e);
        const data = testInfo;
        data.subject_uuid = e;
        data.subject_name = subjectName?.name;
        data.chapter_uuid = '';
        data.exam_type = '';
        setTestInfo({ ...data });
    }

    const getChaptersData = (id: any) => {
        GET_CHAPTER_FILTER_LIST(id).then((res: any) => {
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res?.err);
                    setChapterLoading(false);
                    setTestsLoading(true);

                } else {
                    const data = res['rows'];
                    setChapterList(data);
                    setChapterLoading(false);
                    setTestsLoading(true);
                }
            }
        });
    }

    const onChangeChapter = (e: any) => {
        setTestList([]);
        setQuestionsList([]);
        setTestsLoading(false);
        if (e) {
            setTimeout(() => {
                setTestsLoading(true);
            }, 1000);
        } else {
            setTestsLoading(true);
        }
        const chapterName = chapterList?.find((item: any) => item.uuid === e);
        const data = testInfo;
        data.chapter_name = chapterName?.name;
        data.chapter_uuid = e;
        setTestInfo({ ...data });
    }

    const handleExamType = (value: any) => {
        const data = testInfo;
        if (value === "CHAPTER_WISE_TEST") {
            data.chapter_uuid = "";
            data.chapter_name = "";
        }
        data.exam_type = value;
        setTestInfo({ ...data });
        setTestsLoading(false);
        setTimeout(() => {
            setTestsLoading(true);
        }, 1000);
    }


    const onChangeTest = (e: any) => {
        filterData.uuid = e;
        setQuestionsList([]);
        setCanSelectTest(true);
        if (e) {
            setQuestionsLoading(true);
            setLoading(true);
            GET_ABHYAS_QUESTION_LIST(e, {}).then((res: any) => {
                if (res) {
                    if (res.status === 'fail') {
                        toast.error(res?.err);
                        setQuestionsLoading(false);
                        setLoading(false);
                    } else {
                        const data = res.rows;
                        if (data.length > 0) {
                            data?.forEach((element: any, i: number) => {
                                element.created_dt = moment(element?.created_dt?.split("T")[0]).format('DD-MM-yyyy');
                                if (element?.modified_dt) {
                                    element.modified_dt = moment(element?.modified_dt?.split("T")[0]).format('DD-MM-yyyy');
                                }
                                element.data = JSON.parse(element?.data)
                            });
                            setQuestionsList(data[0]?.data);
                            setQuestionsLoading(false);
                            getmediumData(data[0].board_uuid);
                            getStandardData(data[0].medium_uuid);
                            getSubjectsData(data[0].standard_uuid);
                            getChaptersData(data[0].subject_uuid);
                            setTimeout(() => {
                                setLoading(false);
                                setCanShowTestQuestions(true);
                            }, 1000);
                        }
                    }
                }
            });
        }
    }
    const handleRefresh = () => {
        setMediumList([]);
        setStandardList([]);
        setSubjectList([]);
        setChapterList([]);
        setTestList([]);
        setQuestionsList([]);
        const data = {};
        setTestInfo({ ...data });
        filterForm.current.reset();
        setTestsLoading(false);
        setTimeout(() => {
            setTestsLoading(true);
        }, 1000);
    }

    const onChangeAddUpdateTest = (data: any) => {
        setLoading(false);
        setTimeout(() => {
            setTestsLoading(true);
        }, 1000);
        if (data) {
            getmediumData(data.board_uuid);
            getStandardData(data.medium_uuid);
            getSubjectsData(data.standard_uuid);
            getChaptersData(data.subject_uuid);
        }
    }

    const onClickBackTest = (data: any) => {
        setCanShowTestQuestions(false);
        setLoading(true);
        setTestsLoading(false);
        setTimeout(() => {
            setLoading(false);
            setTestsLoading(true);
        }, 1000);
        setCanSelectTest(false);
    }
    const validationFilters = () => {
        if (testInfo?.board_uuid && testInfo?.medium_uuid && testInfo?.standard_uuid && testInfo?.subject_uuid && testInfo?.exam_type) {
            if (testInfo?.exam_type === "CHAPTER_WISE_TEST" && !testInfo?.chapter_uuid) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    const getDisabledFilters = (data: any) => {
        if (canSelectTest) {
            return true;
        } else {
            return false;
        }
    }
    return (
        <div className="row border-top border-primary py-3" >
            <Breadcum breadcumList={breadcumInfo} textLowerCase={true} />
            <ul className="nav nav-tabs custom-tabs scrolling_nav">
                <li className="nav-item">
                    <NavLink className="nav-link active" to={{ pathname: `/dashboard/content/pariksha/test-creation`, state: { data: "" } }}>Test Creation</NavLink>
                </li>
            </ul>
            {loading &&
                <div className="text-center p-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            }
            {!loading &&
                <div className='my-3'>
                    {!canShowTestQuestions && <div>
                        <FormBuilder onUpdate={handleInput}>
                            <form ref={filterForm}>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className='mb-4'>
                                            <label>Board</label>
                                            <select name="board_uuid" id="board_uuid" className="form-select ft-14" value={testInfo?.board_uuid} onChange={(e) => { onChangeBoard(e.target.value) }}>
                                                <option value="">Select Board</option>
                                                {boardsList?.map((name: any, i: number) => (
                                                    <option key={i} value={name?.uuid}>
                                                        {name?.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='mb-4 position-relative'>
                                            <label>Medium</label>
                                            <select name="medium_uuid" id="medium_uuid" className="form-select ft-14" disabled={getDisabledFilters(testInfo)} value={testInfo?.medium_uuid} onChange={(e) => { onChangeMedium(e.target.value) }}>
                                                <option value="">Select Medium</option>
                                                {mediumList?.map((name: any, i: number) => (
                                                    <option key={i} value={name?.uuid}>
                                                        {name?.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='mb-4  position-relative'>
                                            <label>Standard</label>
                                            <select name="standard_uuid" id="standard_uuid" className="form-select ft-14" disabled={getDisabledFilters(testInfo)} value={testInfo?.standard_uuid} onChange={(e) => { onChangeStandard(e.target.value) }}>
                                                <option value="">Select Standard</option>
                                                {standardList?.map((name: any, i: number) => (
                                                    <option key={i} value={name?.uuid}>
                                                        {name?.standard}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='mb-4  position-relative'>
                                            <label>Subject</label>
                                            <select name="subject_uuid" id="subject_uuid" className="form-select ft-14" disabled={getDisabledFilters(testInfo)} value={testInfo?.subject_uuid} onChange={(e) => { onChangeSubject(e.target.value) }}>
                                                <option value="">Select Subject</option>
                                                {subjectList?.map((name: any, i: number) => (
                                                    <option key={i} value={name?.uuid}>
                                                        {name?.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='mb-4  position-relative'>
                                            <label>Exam Type</label>
                                            <select name="exam_type" id="exam_type" className="form-select f14" disabled={getDisabledFilters(testInfo)} value={testInfo?.exam_type} onChange={(e) => { handleExamType(e.target.value) }} >
                                                <option value="">Select Type</option>
                                                <option value="CHAPTER_WISE_TEST">CHAPTER WISE TEST</option>
                                                <option value="UNIT_TEST_1">UNIT TEST 1</option>
                                                <option value="UNIT_TEST_2">UNIT TEST 2</option>
                                                <option value="SEMESTER_TEST">SEMESTER TEST</option>
                                                <option value="PRE_BOARD_TEST">PRE BOARD TEST</option>
                                                <option value="FINAL_TEST">FINAL TEST</option>
                                                <option value="GROUP_TEST">GROUP TEST</option>
                                            </select>
                                        </div>
                                    </div>
                                    {testInfo?.exam_type === "CHAPTER_WISE_TEST" && <div className="col-md-3">
                                        <div className='mb-4  position-relative'>
                                            <label>Chapter</label>
                                            <select name="chapter_uuid" id="chapter_uuid" className="form-select ft-14" disabled={getDisabledFilters(testInfo)} value={testInfo?.chapter_uuid} onChange={(e) => { onChangeChapter(e.target.value) }}>
                                                <option value="">Select Chapter</option>
                                                {chapterList?.map((name: any, i: number) => (
                                                    <option key={i} value={name?.uuid}>
                                                        {name?.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>}

                                    <div className="col-md-3 ">
                                        <button className="btn clear-btn cursor-pointer mt-4" type="button" style={{ height: '35px' }} onClick={() => handleRefresh()}>
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </FormBuilder>
                    </div>
                    }
                    {/* // Question // */}
                    {loadingData && <div>
                        {(testsLoading && !canShowTestQuestions && !validationFilters()) &&
                            <ContentParikshaTestDataList isLinked={"false"} filterData={testInfo} updateList={onChangeAddUpdateTest} selectTest={onChangeTest} chapterList={chapterList} />
                        }
                        {canShowTestQuestions &&
                            <ContentParikshaAddTestQuestion test_uuid={filterData?.uuid} setBackQuestionsList={onClickBackTest} />
                        }
                    </div>}
                </div>
            }

        </div>
    )
}